import React, {ReactNode} from 'react';
import style from './style.module.scss';
import {IHandlers, IProps} from './types';
import {appValues} from "appRoot/app.constants";
import {BookingMethods, BookingType} from "app/app.types";
import IconButton from 'app/common/iconButton/index';
import {IconTypes} from "app/services/icons/icons.types";
import MuiTypography from "@material-ui/core/Typography";
import {Tooltip, withStyles} from "@material-ui/core";
import MuiButton from "@material-ui/core/Button";
import CheckIcon from "@material-ui/icons/Check";
import {renderIf} from "app/services/reactUtils.service";
import {BookingNewCtrlStates} from "app/bookings/new/types/newBooking.types";
import IconsService from "app/services/icons/icons.service";
import CircularProgress from "@material-ui/core/CircularProgress";
import {IntlService} from "external-services/intl-service/index";
import AppThemeService from 'app/services/theme/appTheme.service';

const NS = 'BookingDialogHeader';

const Heading = withStyles({
  root: {
    marginLeft: 13,
    fontSize: '2.1rem'
  }
})(MuiTypography);

const {palette} = AppThemeService.getAppTheme();

export default function BookingDialogHeader({
    isNewBooking, bookingType, bookingMethod, bookingState, canSave, isSaving, headerOverride, isLocked,
    handleSetBookingMethod, handleCheckForSave, handleToggleLocked, isLoading, venueVisitedCount, averageSpendAmount, currency
  }: IProps & IHandlers) {

  const SaveBtn = withStyles({
    root: {
      color: canSave ? '#fff' : 'rgba(0, 0, 0, 0.26)',
      backgroundColor: canSave ? palette.primary.main : '#616161',
      '&[disabled]': {
        color: 'rgba(0, 0, 0, 0.26)',
        backgroundColor: '#616161'
      }
    }
  })(MuiButton);

  let headerIconType: IconTypes;
  let headerTooltip: string;
  let _HeaderIcon: ReactNode;
  if (bookingMethod === BookingMethods.walkin) {
    headerIconType = IconTypes.walkIn;
    headerTooltip = 'Walk in';
  } else if (bookingType === BookingType.StandbyList) {
    headerTooltip = 'Standby list';
    headerIconType = IconTypes.standbyList;
  }

  if (bookingState === BookingNewCtrlStates.SUCCESS) {
    headerTooltip = bookingMethod === BookingMethods.email ? 'Email' : 'Phone';
    headerIconType = bookingMethod === BookingMethods.email ? IconTypes.mail : IconTypes.phone;
  }


  if (headerIconType) {
    _HeaderIcon = IconsService.getIcon(headerIconType);
  }

  const HeaderIcon = headerIconType ? withStyles({
    root: {
      fontSize: '2.6rem',
      margin: '-3px -5px 0 13px'
    }
  })(_HeaderIcon as any) : null;

  return (
    <div className={style.root}>

      <div className={style.dragHandle} data-drag-handle>
        {/* This is the handler for the AngularJS 'draggable' directive. It is nested so that touch devices don't block the buttons. */}
      </div>

      <div className={style.versionRow}>
        <p>{appValues.VERSION_SHORT}</p>
      </div>
      <div className={style.mainRow}>
        <div>
          {renderIf(isNewBooking &&
            bookingState === BookingNewCtrlStates.ENTER &&
            bookingMethod !== BookingMethods.walkin, () => (
            <>
              <IconButton
                iconType={IconTypes.phone}
                useUnderlinedVersion={true}
                isSelected={bookingMethod === BookingMethods.phone}
                useReversedColors={true}
                clearMargins={true}
                clickHandler={() => handleSetBookingMethod(BookingMethods.phone)}
              />

              <IconButton
                iconType={IconTypes.mail}
                useUnderlinedVersion={true}
                isSelected={bookingMethod === BookingMethods.email}
                useReversedColors={true}
                clearMargins={true}
                clickHandler={() => handleSetBookingMethod(BookingMethods.email)}
              />
            </>
          ))}

          {renderIf(HeaderIcon, () => (
            <Tooltip title={headerTooltip}>
              <HeaderIcon />
            </Tooltip>
          ))}

          <Heading variant="h2" >
            {headerOverride || 'New Booking'}
          </Heading>
          {
            venueVisitedCount > 1 &&
            <div className={style.venueVisitCounter}>
              <span>Visits</span>
              <span>{venueVisitedCount}</span>
            </div>
          }
        </div>

        <div>
          {
            renderIf(averageSpendAmount, () => (
              <div className={style.averageSpendAmount}>
                <span>AVG spend</span>
                {IntlService.currencyValueAsString(averageSpendAmount, currency)}
              </div>
            ))
          }
          {renderIf((bookingState === BookingNewCtrlStates.ENTER), () => (
            <>
              <IconButton
                iconType={isLocked ? IconTypes.lock : IconTypes.unlock}
                useUnderlinedVersion={true}
                useReversedColors={true}
                clearMargins={true}
                tooltip={isLocked ? 'Locked' : 'Unlocked'}
                clickHandler={handleToggleLocked}
              />

              <div className={style.saveBtnWrap}>
                {renderIf(isLoading, () => (
                  <CircularProgress size={20} className={style.nextLoader} />
                ))}
                <SaveBtn
                  variant="contained" color="primary"
                  disabled={isSaving}
                  onClick={handleCheckForSave}
                  startIcon={<CheckIcon />}
                >
                  Save
                </SaveBtn>
              </div>
            </>
          ))}
        </div>
      </div>
      {/*Is Standby? {bookingType === BookingType.StandbyList ? 'YES' : 'NO'}*/}
    </div>
  )
}
